/** @format */

import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

import { forgotPasswordFetch } from 'services/auth/operation'

import { Input, Button, Label } from 'components'

import userIcon from 'assets/icons/user.svg'
import userFocusIcon from 'assets/icons/userFocus.svg'

export const Forgot = ({ setPage }) => {
  const dispatch = useDispatch()

  const [email, setEmail] = useState('')
  const onSubmit = () =>
    !!email && email.includes('@') && email.includes('.')
      ? dispatch(forgotPasswordFetch())
      : alert('Empty email')

  return (
    <>
      <Input
        onSubmit={onSubmit}
        onChange={setEmail}
        value={email}
        type="text"
        placeholder="E-mail"
        icon={userIcon}
        iconHover={userFocusIcon}
      />
      <Button value="Reset password" event={onSubmit} />
      <Label side="center" text="Login" event={() => setPage('login')} />
      <Label
        side="center"
        text="Registration"
        event={() => setPage('registration')}
      />
    </>
  )
}
